export const cashOutModel = (data = {}) => {
    const model = data || {};
    return {
        LoyaltyLevel: model.loyaltyLevel || 0,
        AccumulatedBonusTarget: model.accumulatedBonusTarget || 0,
    }
}

export const cashOut = (data = {}) => {
    const model = data || {};
    return {
        loyaltyLevel: model.loyaltyLevel || 0,
        accumulatedBonusTarget: model.accumulatedBonusTarget || 0,
        id: model.id || 0,
    }
}

export const cashOytEdit = (data = {}) => {
    const model = data || {};
    return {
        loyaltyLevel: model.loyaltyLevel || 0,
        accumulatedBonusTarget: (model.accumulatedBonusTarget || 0),
        id: model.id || 0,
    }
}